var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"env-block row",class:{ active: _vm.envitem.active}},[_c('img',{attrs:{"src":'/'+_vm.envitem.image}}),_vm._v(" "+_vm._s(_vm.envitem.title)+" - "+_vm._s(_vm.envitem.image)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }